export default [
  {
    path: '/admin/defines/offer-terms',
    name: 'OfferTerms',
    component: () => import('@/views/Admin/Defines/Offer_terms/Index.vue'),
    meta: {
      pageTitle: 'Teklif Özel Şartları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/offer-terms/add',
    name: 'OfferTermAdd',
    component: () => import('@/views/Admin/Defines/Offer_terms/Add.vue'),
    meta: {
      pageTitle: 'Teklif Özel Şartları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/offer-terms',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/offer-terms/edit/:id',
    name: 'OfferTermEdit',
    component: () => import('@/views/Admin/Defines/Offer_terms/Edit.vue'),
    meta: {
      pageTitle: 'Teklif Özel Şartları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/offer-terms',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
